import BadgeList from './badge-list';
export default BadgeList;